function wrapViewTransition (callback) {
  if (document.startViewTransition) {
    return document.startViewTransition(callback)
  } else {
    callback()
  }
}

export { wrapViewTransition }
